import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})

export default class Breadcrumb extends Vue {
    @Prop() routes!: any;
}
